import { useEffect, useState } from 'react';

import { Login, ForgotPassword } from '@artegeie/mrc/auth';
import { useAuth } from '@artegeie/mrc/context';
import { onLogin, onLogout } from '@artegeie/mona-sdk/auth'

import useMrcAuth from 'Hooks/useMrcAuth';
import useTranslation from 'Hooks/useTranslation';

import Loader from 'Components/Layout/Loader';

import 'scss/components/content/account.scss';
import 'scss/components/content/_account-login.scss';
import 'scss/components/content/_account-lost-password.scss';

export default function AccountLogin() {

	const { blogUrl } = window.appConfig;
	const referrer = document.referrer;
	let from = referrer || blogUrl;

	const { user } = useAuth();

	const authMrc = useMrcAuth();
	const { t } = useTranslation();

	// loader
	const { loader } = window.appConfig;
	const [loading, setLoading] = useState(true);

	const [ onLostPass, setOnLostPass ] = useState(false);
	const [ onCancelPass, setOnCancelPass ] = useState(true);

	const onForgotPassword = () => {
		setOnLostPass( true );
		setOnCancelPass( false );
	}
	const onPassworCancel = () => {
		setOnLostPass( false );
		setOnCancelPass( true );
	}

	useEffect(() => {
		onLogin((detail) => {

			window.location.href = from;

		});
	}, [] );

	useEffect(() => {
		if ( authMrc.token ) {
			setLoading(false);
		}
	}, [ authMrc.token ] );

	setTimeout(
		() => setLoading(false),
		loader.timeout
	);

	return (

		<div id='account-page' className="account-login">
			{ loading && <Loader /> }

			{ ! authMrc.loginState &&
			<>
				<div id='login-container'>
					{ ( ! onLostPass && onCancelPass ) && <Login onForgotPassword={onForgotPassword} /> }

				</div>
				<div className="account-lost-password">
					{ ( onLostPass && ! onCancelPass ) && <ForgotPassword onCancel={onPassworCancel}/> }
				</div>
				<div>
					{ t('loginText') }<br/>
					{ t('loginTextLine2') }<br/>
					<a className='register' href={ blogUrl + 'account-register/' }>{ t('newRegistration') }</a>
				</div>
			</> }
			{ authMrc.loginState && <p>{ t('account.welcome.hello') } {user.firstName} {user.lastName}.</p> }
		</div>
	);
};

